import React, { useState } from 'react';
import SkeletonLoader from 'src/components/common/skeletonLoading';
import { LayoutCardsColumns, TextModal, WrapperButton } from '../Retencion.styles';
import { Button } from '@habitech/call-to-action';
import { postExpandValidity } from 'src/apis/expandValidity';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import Modal from 'src/components/common/modal/Modal';
import { updateTicketExpandValidity } from 'src/redux/expand_validity/thunks';
import { TicketStatusID } from 'src/models/TicketStatus';
import { formatDataTicket } from 'src/redux/expand_validity/helper';
import ExpandValiditySection from './ExpandValiditySection';
import UserScoreRecommendation from './UserScoreRecommendation';

const initStateModal = {
    show: false,
    text: '',
    success: false,
};

const UserInfo = ({ isUserRetention, data, loading }) => {
    const token = useAppSelector((state) => state.User.token);
    const [modal, setModal] = useState(initStateModal);
    const [loadingExpand, setLoadingExpand] = useState(false);
    const dispatch = useAppDispatch();

    if (loading)
        return (
            <>
                <SkeletonLoader width="254px" height="20px" count={3} />
                <SkeletonLoader width="180px" height="20px" count={2} />
                <SkeletonLoader width="200px" height="20px" count={3} />
                <SkeletonLoader width="117px" height="20px" />
            </>
        );
    const { total_edit, total_interest, total_to_expire, total_aproved, total_off_the_market, total_published, total_expand } = data;

    const handleExpandValidity = (group: string) => {
        const dataPost = {
            country: 'MX',
            user_id: data.user_id,
            group: group.split('-'),
            source: 'cs',
        };
        if (!data.assigned_user_id || !data.attention_id) {
            setModal({
                show: true,
                text: 'Debe asignar un usuario customer success (responsable del ticket) y el tipo de atención',
                success: false,
            });
        } else {
            setLoadingExpand(true);
            postExpandValidity(dataPost, token).then((res) => {
                if (res.success) {
                    setModal({
                        show: true,
                        text: 'Se extendió la vigencia con éxito',
                        success: true,
                    });
                } else {
                    setModal({
                        show: true,
                        text: 'Hubo un error en el envío, intente nuevamente',
                        success: false,
                    });
                }
                setLoadingExpand(false);
            });
        }
    };

    const handleClose = () => {
        if (modal.success) {
            const newData = formatDataTicket(data);
            const dataTicket = { id: data.id, ticket_status: TicketStatusID.close, ...newData };
            setLoadingExpand(true);
            dispatch(updateTicketExpandValidity(dataTicket)).then(() => window.location.reload());
        } else {
            setModal(initStateModal);
        }
    };
    return (
        <LayoutCardsColumns>
            <div className="containerLabel gap-10">
                <span className="label">Publicaciones Totales:</span>
                <div className="label-status">{total_published}</div>
            </div>
            <div className="containerLabel gap-10">
                <span className="label">Activas:</span>
                <div className="label-status">{total_aproved}</div>
            </div>
            <div className="containerLabel gap-10">
                <span className="label">Fuera de mercado:</span>
                <div className="label-status">{total_off_the_market}</div>
            </div>

            {
                isUserRetention && (
                    <UserScoreRecommendation array_suggestions={data.suggestions} />
                )
            }
            {!isUserRetention && (
                <ExpandValiditySection
                    total_to_expire={total_to_expire}
                    total_interest={total_interest}
                    total_edit={total_edit}
                    total_expand={total_expand}
                    loadingExpand={loadingExpand}
                    handleExpandValidity={handleExpandValidity}
                />
            )}

            {modal.show && (
                <Modal onClose={handleClose}>
                    <TextModal>{modal.text}</TextModal>
                    <WrapperButton>
                        <Button dataId="button-search" originType="pcom" size="large" onClick={handleClose} loading={loadingExpand}>
                            Aceptar
                        </Button>
                    </WrapperButton>
                </Modal>
            )}
        </LayoutCardsColumns>
    );
};

export default UserInfo;
